/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_EyebrowInputs */

const en_directory_agents_eyebrow = /** @type {(inputs: Directory_Agents_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For AI agents`)
};

const zh_directory_agents_eyebrow = /** @type {(inputs: Directory_Agents_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`面向 AI Agent`)
};

/**
* | output |
* | --- |
* | "For AI agents" |
*
* @param {Directory_Agents_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_eyebrow = /** @type {((inputs?: Directory_Agents_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_eyebrow(inputs)
	return zh_directory_agents_eyebrow(inputs)
});
export { directory_agents_eyebrow as "directory.agents.eyebrow" }